module.exports = __webpack_public_path__ + "static/kraken_priest-5124412ae08ace7a4f26fe1d42a381bc.png";